module.exports = __webpack_public_path__ + "img/Success_ReceivedToTransport@2x.3c0a4579.png";